

import httpUtil from "@/utils/httpUtil";

//获取设备列表
export const getDeviceList = params => httpUtil.get("/gpsDevice", params);
//不分页设备列表
export const getNoPage = params => httpUtil.get("/gpsDevice/noPage", params);

export const getDeviceInfo = params => httpUtil.get("/gpsDevice/getDeviceInfo", params);

//新增或修改设备
export const add = params => httpUtil.post("/gpsDevice", params);

export const delDevice = params => httpUtil.post("/gpsDevice/delete", params);
// 参数设置
export const parameter = params => httpUtil.post("/gpsDevice/parameter", params);

export const isRecycle = params => httpUtil.get("/gpsDevice/isRecycle", params);
export const log = params => httpUtil.get("/gpsDevice/log", params);
export const getDearler = params => httpUtil.get("/gpsDevice/dealer", params)
export const recycle = params => httpUtil.get("/gpsDevice/recycle", params)
export const warning = params => httpUtil.get("/gpsDevice/warning", params)
export const getFleeingData = params => httpUtil.get("/gpsDevice/fleeingData", params)
export const changeStatus = params => httpUtil.get("/gpsDevice/changeStatus", params)
export const fetchDealerAddress = params => httpUtil.get("/gpsDevice/dealerInfo", params)
export const company = params => httpUtil.get("/gpsDevice/getCompany", params)
export const importExcel = params => httpUtil.post("/gpsDevice/importExcel", params)
export const getDeviceLog = params => httpUtil.get("/gpsDevice/getDeviceLog", params)
export const allKnow = params => httpUtil.post("/gpsDevice/allKnow", params)
export const getNum = params => httpUtil.get("/gpsDevice/getNum", params)
export const getDealerNum = params => httpUtil.get("/gpsDevice/getDealerNum", params)
export const getSuspectNum = params => httpUtil.get("/gpsDevice/getSuspectNum", params)
export const getDeviceInfoById = params => httpUtil.get("/gpsDevice/getDeviceInfoById", params)
export const getDealerInfoByName = params => httpUtil.get("/gpsDevice/getDealerInfoByName", params)
export const updateDeviceIsSuspect = params => httpUtil.get("/gpsDevice/updateDeviceIsSuspect", params)
export const mapShow = params => httpUtil.get("/gpsDevice/mapShow", params)
